<template>
    <div id="app">
      <div id="wrapper" class="pc">
        <app-header></app-header>
        <router-view ref="mainPage"></router-view>
        <app-footer></app-footer>
        <app-menu></app-menu>
      </div>
      <div id="wrapper" class="mobile">
        <router-view ref="mainPage"></router-view>
        <app-Xmenu></app-Xmenu>
        <div><app-XFooter></app-XFooter></div>
      </div>
    </div>
  </template>

<script>
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'
import Menu from '@/components/Menu/Menu.vue'
import XMenu from '@/components/XMenu/XMenu.vue'
import XFooter from '@/components/XFooter/XFooter.vue'
export default {
  name: 'app',
  data() {
    return {
      isSearch: true
    };
  },
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'app-menu': Menu,
    'app-Xmenu': XMenu,
    'app-XFooter':XFooter,
  },
}
</script>
<style>
@import './assets/css/style.css';
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */

  min-width: pxTorem(1250);
  height: 100%;
  min-height: pxTorem(600);
  position: relative;
}
#wrapper{
  position: relative;
  padding-bottom: 0;
  height: 100%;
  min-height: 600px;
}
.navTwo{
  margin-top: -3px;
  margin-left: -5px;
  width: 110px;
}
.navTwo .el-menu{
  background: rgba(0,0,0,0.3);
  border: solid 2px #fff;
  border-radius: 0 0 8px 8px;
  border-top: none ;
}
.navTwo .el-menu .el-menu-item{
  width: 120px;
  background: none !important ;
  color: rgb(233, 231, 231) !important;
  font-size: 18px;
  font-weight: 600;
}
.navTwo .el-menu--popup{
  min-width: 126px;
  text-align: center;
}
.navTwo .el-menu .el-menu-item:hover{
  color: #fff !important;
  border-radius: 5px;
  font-size: 19px;
  background: none !important;
}
.navTwo .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
  background-color: none ;
}
.navTwo .el-dropdown-menu__item, .el-menu-item{
  padding: 0 !important;
}
</style>
